import React from 'react';
// import "./styles/Marquee.scss";
import { FaVolumeUp } from 'react-icons/fa';

// Type assertion for react-icons compatibility
const VolumeUp = FaVolumeUp as React.ComponentType<React.SVGProps<SVGSVGElement>>;

interface MarqueeProps {
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  text5: string;

}

const MenuMarquee: React.FC<MarqueeProps> = ({ text1, text2, text3, text4, text5 }) => (
  <div className="menu-marquee-container">
    <div className="menu-marquee-text">
    <VolumeUp style={{paddingBottom:"3px"}} /> {text1} &nbsp;<VolumeUp style={{paddingBottom:"3px"}} /> {text2} &nbsp;<VolumeUp style={{paddingBottom:"3px"}} />{text3} &nbsp; <VolumeUp style={{paddingBottom:"3px"}} /> {text4} &nbsp;<VolumeUp style={{paddingBottom:"3px"}} /> {text5}
    </div>
  </div>
);

export default MenuMarquee;